import { call } from 'redux-saga/effects'
import { CallApi } from '../api/callApi'
import { APIS } from '../../_config'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* submitOnboardingData(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.POST, APIS.ONBOARDING.SUBMIT_ONBOARDING_DATA_REQUEST, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to submit onboarding data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'submitOnboardingData', action: action.type })
    }
}

export function* getOnboardingDataList(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.GET, APIS.ONBOARDING.GET_ONBOARDING_DATA_LIST, action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to get onboarding data list',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getOnboardingDataList', action: action.type })
    }
}

export function* deleteOnboardingData(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.DELETE, APIS.ONBOARDING.DELETE_ONBOARDING_DATA(action.payload.literal), {})
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to delete onboarding data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'deleteOnboardingData', action: action.type })
    }
}

export function* createOnboardingData(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.POST, APIS.ONBOARDING.CREATE_ONBOARDING_DATA, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to create onboarding data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'createOnboardingData', action: action.type })
    }
}

export function* updateOnboardingData(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.PUT, APIS.ONBOARDING.UPDATE_ONBOARDING_DATA(action.payload.literal), action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to update onboarding data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'updateOnboardingData', action: action.type })
    }
}

export function* getOnboardingDataById(action: any): Generator<any, void, any> {
    try {
        const resp = yield call(CallApi.GET, APIS.ONBOARDING.GET_ONBOARDING_DATA_BY_ID(action.payload.literal), action.payload, false)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action.onSuccess(resp.data as SuccessResponse<any>)
        } else {
            action.onError(resp.data as ErrorResponse<any>)
        }
    } catch (e: any) {
        // action.onError(e.data)
        // ✅ CHANGED: Added null check and fallback error object
        action.onError(
            e?.data || {
                message: e?.message || 'Failed to get onboarding data by ID',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getOnboardingDataById', action: action.type })
    }
}
